module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/facebook.37452dd6.svg";